import { EditEmployee } from '@features/Contractor/Employee/Edit'
import { useEmployeeContext } from '@features/Contractor/Employee/EmployeeContext'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const EditEmployeeRoute: React.FC = () => {
  const { contractorId } = Route.useParams()
  const { data, courses, isLoading, isError, refetch } = useEmployeeContext()

  return (
    <EditEmployee
      contractorId={contractorId}
      data={data}
      courses={courses}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
    />
  )
}

export const Route = createFileRoute('/contractor/$contractorId/employees/$employeeId/edit')({
  component: EditEmployeeRoute,
  staticData: {
    breadcrumb: t('contractor.editEmployee.title'),
  },
})
